import './fioc.scss';

import React from 'react';
import { connect } from 'react-redux';
import { history } from 'routes/history';
import { bindActionCreators } from 'redux';
import { LOAN } from '../../constants/userProfile';
import FullForm from '../Layouts/FullForm';
import { recordPage, recordEventCustomOnly } from 'utilities/uTagging';
import { accountTypeModel } from 'utilities/professionHelper';
import { loanStatus } from '../../actions/aresActions';
import { AccountType } from 'components/accountType/';
import { RadioButton } from 'components/RadioButton/RadioButton';
import { actions as formActions } from 'react-redux-form';
import { formatText } from 'core/i18n';
import Disclaimer from 'components/containers/disclaimer';
import modalCancelActions from 'actions/modalCancelActions';
import preLoaderActions from 'actions/preLoaderActions';
import stepsActions from 'actions/stepsActions';
import createActions from 'actions/createActions';
import { BASE_PATH } from 'constants/index';
import accountTypeActions from 'actions/accountTypeActions';
import { dispatchFieldErrors } from 'actions/fiocActions';
import { SELF_EMPLOYED_ID } from '../../utilities/professionHelper';
import { setPageName } from 'actions/errorViewNavigation';

class FIOC extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const { preLoaderActions, setPageName } = this.props;
        preLoaderActions.hidePreLoader();
        const pageName = '/onboarding/tu-actividad/';
        setPageName(pageName);
        recordPage(
            pageName,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            'ares',
            {
                tipoPagina: 'generica',
                tipoProceso: 'onboarding',
                pasoProceso: 'tu-actividad',
                productoOnboardingDetalle: 'prestamo ares',
            }
        );
    }

    handleSubmit = () => {
        const { userProfile, preLoaderActions, dispatch } = this.props;

        if (!this.handleDisableButton()) {
            dispatch(dispatchFieldErrors(userProfile));

            return;
        }

        preLoaderActions.showPreLoader();
        userProfile.accountType === SELF_EMPLOYED_ID ? this.saveSelfEmployedInformation() : this.clientVerify();
    };

    saveSelfEmployedInformation() {
        const {
            userProfile: { profession_cnae_answer, accessToken, profession_id, profession_category },
            accountTypeActions,
        } = this.props;

        const profession = {
            option: profession_cnae_answer,
            subcategory: profession_id,
            id: profession_category,
        };

        accountTypeActions.saveSelfEmployedInformation({ profession }, accessToken, saved => {
            if (!saved) {
                history.push(`${BASE_PATH}/errors`);

                return;
            }
            this.clientVerify();
        });
    }

    clientVerify() {
        const {
            userProfile: { accessToken },
            stepsActions,
            createActions,
            getLoanStatus,
        } = this.props;

        stepsActions.clientVerify(accessToken, verified => {
            if (!verified) {
                history.push(`${BASE_PATH}/errors`);

                return;
            }

            createActions.loanCreate(accessToken, () => {
                getLoanStatus();
            });
        });
    }

    getWorkFor() {
        const { userProfile } = this.props;
        const workFor = [
            { value: '02', label: formatText('informationText-workFor02') },
            { value: '01', label: formatText('informationText-workFor01') },
            { value: '03', label: formatText('informationText-workFor03') },
            { value: '04', label: formatText('informationText-workFor04') },
            { value: '05', label: formatText('informationText-workFor05') },
        ];
        if (userProfile.investmentType === LOAN) {
            workFor.splice(4, 1);
        }

        return workFor;
    }

    handleDisableButton = () => {
        const { userProfile } = this.props;
        const accountTypeModelString = accountTypeModel[userProfile.accountType];
        const conditionalOptions01 = () => {
            if (userProfile.profession_cnae_answer === 'No') {
                return !!userProfile.profession_category && !!userProfile.profession_id;
            }
            if (userProfile.profession_cnae_answer === 'Si') {
                return !!userProfile.profession_id;
            }

            return false;
        };

        switch (userProfile.accountType) {
            case '01':
                return (
                    !!userProfile[`${accountTypeModelString}_company`] &&
                    !!userProfile[`${accountTypeModelString}_annualIncomeAmount`] &&
                    conditionalOptions01()
                );

            case '02':
                return (
                    !!userProfile[`${accountTypeModelString}_annualIncomeAmount`] &&
                    !!userProfile[`${accountTypeModelString}_company`] &&
                    !!userProfile.profession_option &&
                    !!userProfile.profession_category &&
                    !!userProfile.cno2_profession_id
                );

            case '03':
                return !!userProfile[`${accountTypeModelString}_annualIncomeAmount`];
            case '04':
                return !!userProfile[`${accountTypeModelString}_annualIncomeAmount`];
            default:
                return false;
        }
    };

    render() {
        const { userProfile, options } = this.props;

        return (
            <FullForm
                buttonContinueFakeDisabled={!this.handleDisableButton()}
                className="ares fioc form"
                title={formatText('stepsTitles-professionalDataTitle')}
                subtitle={formatText('stepsTitles-professionalDataDescription')}
                hideRoadMapNavigation={false}
                continueAction={() =>
                    recordEventCustomOnly({
                        accionEvento: 'continuar',
                        categoriaEvento: 'interaccion en tu actividad',
                    })
                }
                cancelAction={() => {
                    const { modalCancelActions } = this.props;
                    modalCancelActions.showModalCancel();
                    recordEventCustomOnly({
                        accionEvento: 'salir',
                        categoriaEvento: 'interaccion en tu actividad',
                    });
                }}
                formModel="userProfile"
                continueButtonEnabled={true}
                onSubmit={this.handleSubmit}
            >
                <div className="row prospects-separator prospects-gutter">
                    <div className="col-sm-12 md-form-group">
                        <Disclaimer>
                            <label className="fioc__disclaimer">
                                {formatText('stepsTitles-professionalDataDisclaimer')}
                            </label>
                        </Disclaimer>
                        <RadioButton
                            profileModel="userProfile.accountType"
                            label={formatText('field-workBy_ares')}
                            optionsList={this.getWorkFor()}
                            disabled={true}
                            focusAnimated
                            onFocus={() =>
                                recordEventCustomOnly({
                                    categoriaEvento: 'interaccion en tu actividad',
                                    accionEvento: 'situacion actual',
                                })
                            }
                            {...this.props}
                        />
                        {!options.get('isLoadingAres') && (
                            <AccountType typeId={userProfile.accountType} {...this.props} />
                        )}
                    </div>
                </div>
            </FullForm>
        );
    }
}

export default connect(
    state => ({
        userProfile: state.userProfile,
        options: state.options,
        userProfileForm: state.userProfileForm,
    }),
    dispatch => ({
        formActions: bindActionCreators(formActions, dispatch),
        preLoaderActions: bindActionCreators(preLoaderActions, dispatch),
        stepsActions: bindActionCreators(stepsActions, dispatch),
        modalCancelActions: bindActionCreators(modalCancelActions, dispatch),
        createActions: bindActionCreators(createActions, dispatch),
        accountTypeActions: bindActionCreators(accountTypeActions, dispatch),
        getLoanStatus: bindActionCreators(loanStatus, dispatch),
        setPageName: bindActionCreators(setPageName, dispatch),
    })
)(FIOC);
